module.exports = __webpack_public_path__ + "static/media/country_ki.6aad6bb5.webp";